import { Info } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '~/shared/lib/utils'
import { Tooltip, TooltipContent, TooltipTrigger } from '~/shared/ui/tooltip'

/** A small info icon that explains its neighbour in a tooltip, on hover and on focus. */
export function InfoTooltip({
  label,
  children,
  className,
}: {
  label: string
  children: ReactNode
  className?: string
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={label}
          className={cn(
            'inline-flex size-6 shrink-0 items-center justify-center rounded-full text-muted-foreground outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring',
            className,
          )}
        >
          <Info className="size-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-xs text-pretty">{children}</TooltipContent>
    </Tooltip>
  )
}
